'use client';

import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';
import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';
import { LocationDetailsPageProps } from '@/types/locationDetailsPages/shared';

export default function InstallBannerWrapper({ details }: Pick<LocationDetailsPageProps, 'details'>) {
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', true);
  const deeplinkData = details.locationType === 'park' ? { pageId: details.id, pageType: 'area' } : {};

  return (
    <>
      <InstallBanner {...deeplinkData} isOpen={isBannerOpen} onRequestClose={() => setIsBannerOpen(false)} promptLocation="parks page" />
    </>
  );
}
